// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"309":"b5cc52cc","500":"21234cfa","541":"fe36494f","632":"ba3ccf08","742":"22e63dc3","793":"a3987eff"}[chunkId] + ".chunk.js";
};